// Recovery Time: quanto tempo para desfazer o maximo
// drawdown, a tres retornos ESPERADOS fixos de 20%, 12% e
// 6% ao ano. NAO usa Monte Carlo, volatilidade nem Sharpe.
//
// Existia em CINCO copias, e a quinta DIVERGIA.
//
// As quatro primeiras — card da diamante, prompt da cerebro,
// resposta direta do chat e um dos blocos de contexto — davam
// 49/80/155 meses na carteira de 09/10/2026.
//
// A quinta, no contexto do chat, usava outra formula inteira:
// drawdown dividido pela volatilidade MENSAL vezes 1.5, com
// os cenarios saindo de multiplicadores de 0.6 e 1.8. Dava
// 11/19/34, e era justamente a que o modelo lia. O card ja
// tinha sido corrigido para a formula certa — o comentario
// dele diz "volatilidade mede oscilacao, nao velocidade de
// recuperacao" — e essa ficou atras. Pior: o prompt afirmava
// ao modelo que o numero NAO vinha de volatilidade, enquanto
// o contexto entregava justamente o numero de volatilidade.
//
// Como ela foi achada, porque isso importa mais que ela:
// nao foi pelo detector de duplicata, que compara linha
// normalizada e nao ve copia reescrita. Nao foi por grep,
// que eu rodei com head e truncou uma linha antes dela.
// Foi perguntando ao proprio chat qual linha do contexto
// dele citava "otimista" e "meses" — e ele colou a errada.
//
// A licao: copia que divergiu deixa de ser duplicata e sai
// do radar de qualquer detector de texto. O que sobra e
// comparar a saida de cada caminho com a da tela.
//
// Devolve tambem a propria funcao de meses, para que cada
// sitio mantenha os nomes locais que ja usava e nenhuma das
// strings longas de prompt precise mudar um byte.
export function recoveryTime(maxDrawdownPct) {
  const dd = Math.abs(parseFloat(maxDrawdownPct) || 0) / 100
  if (!(dd > 0)) return null
  const ganho = dd / (1 - dd)
  const meses = (r) =>
    Math.round(Math.log(1 + ganho) / Math.log(1 + r) * 12)
  return {
    dd,
    ganho,
    meses,
    otimista: meses(0.20),
    base: meses(0.12),
    pessimista: meses(0.06),
  }
}
